import { render } from "./packets.vue?vue&type=template&id=e15e1cba"
import script from "./packets.vue?vue&type=script&lang=js"
export * from "./packets.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__